import { cn } from "@/lib/utils";
import { Eye, EyeOff } from "lucide-react";
import * as React from "react";

const Input = React.forwardRef<
	HTMLInputElement,
	React.ComponentProps<"input"> & { eyeColor?: string }
>(({ className, type, eyeColor = "text-gray-500", ...props }, ref) => {
	const [showPassword, setShowPassword] = React.useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	const inputType = type === "password" && showPassword ? "text" : type;

	return (
		<div className="relative w-full">
			<input
				type={inputType}
				className={cn(
					"selection:text-primary-foreground w-full",
					"aria-invalid:ring-destructive/20 aria-invalid:border-destructive",

					"web-body-b1 border-divider h-14 rounded-[32px] border-1 bg-white p-4 text-black",
					"placeholder:web-body-b1 placeholder:text-black placeholder:opacity-50",
					"hover:border-blue-500",
					"focus-visible:border-blue-500",
					"focus:border-blue-500",
					"disabled:border-divider disabled:opacity-50",
					className
				)}
				{...props}
				ref={ref}
				{...props}
			/>

			{type === "password" && (
				<button
					type="button"
					className="absolute top-1/2 right-5 -translate-y-1/2"
					onClick={togglePasswordVisibility}
				>
					{showPassword ? (
						<Eye className={"h-4 w-4 " + eyeColor} />
					) : (
						<EyeOff className={"h-4 w-4 " + eyeColor} />
					)}
				</button>
			)}
		</div>
	);
});

export { Input };
